module.exports = __webpack_public_path__ + "img/icon-x.cf2eb0a3.svg";